<template>
  <div style="margin: 36px auto; width: 80vw;">
    <el-page-header @back="this.$route.push({path: 'order/order'})" content="订单详情"></el-page-header>
    <el-row :gutter="26" style="margin-top: 36px; padding: 16px;" v-if="Object.keys(orderInformation).length > 0" v>
     <el-col :span="16">
       <div class="detailCell">
         <h3>{{orderInformation.orderNo}}</h3>
         <div style="margin-top: 16px; margin-bottom: 16px;">
           <el-button-group>
             <el-button :type="orderInformation.Status === 200 ? 'success' : 'warning'" size="mini" round>{{orderstatus(orderInformation)}}</el-button>
             <el-button :type="orderInformation.shipmethod ? 'success' : 'warning'" size="mini" round>{{orderInformation.shipmethod ? orderInformation.shipmethod.name : 'Unknow'}}</el-button>
             <el-button :type="orderInformation.paymethod ? 'success' : 'warning'" size="mini" round>{{orderInformation.paymethod ? orderInformation.paymethod.showName : 'Unknow'}}</el-button>
           </el-button-group>
         </div>
         <small>
           <strong>下单时间: </strong>{{dateTimeData(orderInformation.orderTime)}}
           <strong style="margin-left: 16px;">最迟配送时间: </strong>{{dateTimeData(orderInformation.latestDeliveryDate)}}
           <el-dropdown :hide-on-click="false" style="margin-left: 26px;">
            <span class="el-dropdown-link">
              <strong>订单管理</strong><i class="el-icon-arrow-down el-icon--right"></i>
            </span>
             <el-dropdown-menu slot="dropdown">
               <el-dropdown-item><el-button type="text">发货</el-button></el-dropdown-item>
               <el-dropdown-item><el-button @click="rechargeVerify(orderInformation.orderNo)" type="text">收款认证</el-button></el-dropdown-item>
             </el-dropdown-menu>
           </el-dropdown>
         </small>
       </div>
       <div class="detailCell">
         <el-table :data="orderInformation.orderitem_set">
           <el-table-column>
             <template slot-scope="scope">
               <el-image
                 style="width: 100px; height: 100px"
                 :src="scope.row.product.cover"
                 :preview-src-list="[scope.row.product.cover]">
                 :fit="fit"></el-image>
             </template>
           </el-table-column>
           <el-table-column label="产品信息" width="400">
             <template slot-scope="scope">
               <h2>{{scope.row.product.title}}</h2>
               <small>{{scope.row.product.standard.keyString}}</small>
               <fieldset v-if="scope.row.customerize" style="border: 1px dotted #f3d19e;">
                 <legend>定制商品参数</legend>
                 <p v-for="ks in Object.keys(JSON.parse(scope.row.customerize))" :key="ks">
                   <strong>{{ks}}: </strong>{{JSON.parse(scope.row.customerize)[ks]}}
                 </p>
               </fieldset>
             </template>
           </el-table-column>
           <el-table-column label="购买价格" prop="price"></el-table-column>
           <el-table-column label="购买数量" prop="qty"></el-table-column>
           <el-table-column label="最终成交价值" prop="total"></el-table-column>
         </el-table>
       </div>
     </el-col>
      <el-col :span="8">
        <div class="detailCell">
          <span v-if="orderInformation.buyerAddress">
            <div style="width: 100%; display: flex; justify-content: space-between; align-items: stretch;">
              <h3>配送地址</h3>
              <el-button type="text">EDIT</el-button>
            </div>
            {{orderInformation.shippingAddress}},{{orderInformation.country.Name}}
          </span>
          <div v-else style="padding-top: 36px; padding-bottom: 36px; text-align: center;">
            用户配送地址待确认
          </div>
        </div>
        <div class="detailCell">
          <span v-if="orderInformation.buyer">
            <div style="width: 100%; display: flex; justify-content: space-between; align-items: stretch;">
              <h3>买家</h3>
              <el-button type="text">EDIT</el-button>
            </div>
             <div style="margin-top: 14px; margin-bottom: 14px; text-align: center;">
              <el-image :src="orderInformation.buyer.cover" style="width: 160px; height: 160px; border-radius: 80px;" fit></el-image>
            </div>
            {{orderInformation.buyer.email}}
          </span>
          <div v-else style="padding-top: 36px; padding-bottom: 36px; text-align: center;">
            用户配送地址待确认
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'OrderDetail',
  data () {
    return {
      orderInformation: {},
      cmzAttribute: []
    }
  },
  mounted () {
    this.getOrderInfor()
  },
  methods: {
    /**
     * 支付验证
     */
    rechargeVerify: function (orderId) {
      var para = {}
      para.orderId = orderId
      para.method = 'order.rechangeVerify'
      var that = this
      that.$pageloading()
      this.$http.post(that.$apiurl, para).then(function (ret) {
        that.$loadend()
        window.location.reload()
      })
    },
    /**
     * 订单状态
     * @param v
     * @returns {string}
     */
    orderstatus: function (v) {
      if (v.Status === 0) {
        return ('pending')
      } else if (v.Status === 1) {
        return ('Shipping Required')
      } else if (v.Status === 200) {
        return ('Shipped')
      } else if (v.Status === 202) {
        return ('Return')
      }
    },
    /**
     * 订单信息
     */
    getOrderInfor: function () {
      var that = this
      console.log(that.$route.params.id)
      var para = {}
      para.orderNo = that.$route.params.id
      para.method = 'order.getOrderInfor'
      that.$pageloading()
      this.$http.post(that.$apiurl, para).then(function (ret) {
        that.$loadend()
        that.orderInformation = ret.body.data
      })
    },
    /**
     * 时间格式
     * @param dd
     * @returns {string}
     */
    dateTimeData: function (dd) {
      var d = new Date(dd)
      return `${d.toLocaleDateString()} ${d.toLocaleTimeString()}`
    }
  }
}
</script>

<style scoped>
.detailCell{margin-top: 16px; margin-bottom: 16px; padding: 8px; background-color: white;}
</style>



// WEBPACK FOOTER //
// src/components/order/OrderDetail.vue